import { PostRequest } from "@services/http/BaseRequest";
import W2UiFilterBuilder from "@services/w2ui";

const URI_SPAREPARTS = "/admin/spareparts/w2ui";
const URI_SPAREPARTS_TYPES = "/admin/spareparts_types/w2ui";


export interface ISparePartType {
  Id: number;
  Name: string;
  Total: number;
  Pic: string;
}

export interface ISparePart {
  Id: number;
  TypeId: number;
  MinerId: number;
}

export interface ISparePartResponse {
  // "Id": 1,
  // "PartTypeId": 2,
  // "MinerId": 26,
  // "Total": 0,
  // "Name": "test 1717076319532",
  // "MinerStringId": "SERGMSKC777023A101"
  Id: number;
  PartTypeId: number;
  MinerId: number;
  Total: number;
  Name: string; // SparePartType.Name "test 1717076319532",
  MinerStringId: string; //
}

export class SparePartsList extends PostRequest {
  constructor(
    offset: number = 0,
    limit: number = 20,
  ) {
    const builder = new W2UiFilterBuilder()
      .setLimit(limit)
      .setOffset(offset);
    const params = builder.build().stringParams;
    super(URI_SPAREPARTS, params);
  }
}

export class GetSparePartTypesList extends PostRequest {
  constructor(
    offset: number = 0,
    limit: number = 20,
  ) {
    const params = new W2UiFilterBuilder()
      .setOffset(offset)
      .setLimit(limit);
    super(URI_SPAREPARTS_TYPES, params);
  }
}

export class CreateSparePartsType extends PostRequest {
  constructor(
    id: number | "new",
    name: string,    // вентилятор , майнер, питание
  ) {
    const w2ui = new W2UiFilterBuilder().setEdit({
      id: id === 0 ? "new" : id,
      name,
    });
    const params = w2ui.build().stringParams;
    super(URI_SPAREPARTS_TYPES, params);
  }
}

export class CreateSparePart extends PostRequest {
  constructor(
    id: number | "new",
    partTypeId: number,
    minerId?: number,
  ) {
    const w2ui = new W2UiFilterBuilder().setEdit({
      id: id === 0 ? "new" : id,
      PartTypeId: partTypeId,
      MinerId: minerId,
    });
    const params = w2ui.build().stringParams;
    super(URI_SPAREPARTS, params);
  }
}

// deprecated
export class UploadSparePartTypeImage extends PostRequest {
  constructor(
    typeId: number,
    file: Blob
  ) {
    const data = new FormData();
    data.append("id", "" + typeId);
    data.append("file", file);
    super("/admin/spareparts_types/setpic", data);
  }
}

export class UploadSparePartImage extends PostRequest {
  constructor(
    file: Blob
  ) {
    const data = new FormData();
    data.append("file", file);
    super("/admin/spareparts/img/create", data);
  }
}

export class DeleteSparePart extends PostRequest {
  constructor(id: number) {
    const builder = new W2UiFilterBuilder().setDelete(id);
    let params = builder.build().stringParams;
    super(URI_SPAREPARTS, params);
  }
}

export class DeleteSparePartType extends PostRequest {
  constructor(id: number) {
    const builder = new W2UiFilterBuilder().setDelete(id);
    let params = builder.build().stringParams;
    super(URI_SPAREPARTS_TYPES, params);
  }
}

// file - тело картинки : до 10 МБ
// router.POST("/api/admin/spareparts/img/create",

// в ответе
// link - http ссылка на картинку
// hash - используется для формирования массива картинок запчасти или шаблона

// сначала создаем \ заливаем картинки и получаем ссылки на них, затем создаем запчасть / шаблон запачасти